import script from "./BIcon.vue?vue&type=script&setup=true&lang=js"
export * from "./BIcon.vue?vue&type=script&setup=true&lang=js"

import "./BIcon.vue?vue&type=style&index=0&id=2202d7a7&lang=css"

const __exports__ = script;

export default __exports__